import React, { useEffect } from "react";
import "./App.css";
import Header from "./Header";
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Login from "./Login";
import Payment from "./Payment";
import Orders from "./Orders";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Footer from './Footer';
import SubHeader from "./SubHeader";
import AllPopover from "./AllPopover";

const promise = loadStripe(
  "pk_test_51KOdTbSEGDeK0OwUHbsIrtBkHvGILoT2X7iOiOFxBvlQk6zvDBBnQdBTVesdzPWIcgB3va0j9EFHxITlDy5CReRB00cvbi4JJN"
);

function App() {
  const [{}, dispatch] = useStateValue();
  const [{blur},dispatch1]=useStateValue();
  console.log(blur);
  useEffect(() => {
    // will only run once when the app component loads...

    auth.onAuthStateChanged((authUser) => {
      console.log("THE USER IS >>> ", authUser);

      if (authUser) {
        // the user just logged in / the user was logged in

        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <div>
    {blur?<AllPopover />:''}
    <div className={`app ${blur && 'blurs'}`}>
    <Router>
      <Switch>
          <Route path="/orders">
            <Header />
            <SubHeader />
            <Orders />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/checkout">
            <Header />
            <Checkout />
            <Footer />
          </Route>
          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>
          <Route path="/">
            <Header />
            <SubHeader />
            <Home />
            <Footer />
          </Route>
        </Switch>
    </Router>
     </div>
    </div>
  );
}

export default App;